import React from 'react';
import MerchantDashboard from './MerchantDashboard/MerchantDashboard';
import DashboardAdmin from './dashboardAdmin';
import DashboardManager from './dashboardManager';
import DashboardStaff from './staffDashboard';

const Dashboard = ({ role }) => {
    return (
        <div>
            {role === 'admin' && <DashboardAdmin />}
            {role === 'merchant' && <MerchantDashboard />}
            {role === 'staff' && <DashboardStaff />}
            {role === 'manager' && <DashboardManager />}
        </div>
    );
};

export default Dashboard;
